// STYLES
import '../style/main.scss'

// LIBS
import React from 'react'

// COMPONENTS
import Header from '../components/header'
import Footer from '../components/footer'

// INTERFACE
export default ({children}) => (
  <div>
    <Header />
    {children()}
    <Footer />
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/index.js